'use client'

import { useContext } from 'react'

import cn from 'clsx'
import { Heading } from '@/components/Text/Heading'
import type { Themes } from '@/Theme'
import { ThemeContext } from '@/utils/themeContext'

import css from './ArticleBox.module.css'

export type ArticleBoxProps = {
    title: string
    children: React.ReactNode
    className?: string
    /**
     * @deprecated use ThemeProvider instead
     */
    theme?: Themes
}

export function ArticleBox({
    title,
    children,
    className,
    theme: deprecatedTheme = 'twist',
    ...rest
}: ArticleBoxProps) {
    const { theme = deprecatedTheme } = useContext(ThemeContext)

    return (
        <div className={cn(css.articleBox, css[theme], className)} {...rest}>
            <Heading
                className={css.title}
                level="3"
                size="minor-lg"
                weight={theme === 'todoist' ? 'medium' : undefined}
            >
                {title}
            </Heading>

            {children}
        </div>
    )
}
